import { render, staticRenderFns } from "./WalletPromoBanner.vue?vue&type=template&id=3cc2daa2"
import script from "./WalletPromoBanner.vue?vue&type=script&lang=js"
export * from "./WalletPromoBanner.vue?vue&type=script&lang=js"
import style0 from "./WalletPromoBanner.vue?vue&type=style&index=0&id=3cc2daa2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports